// ./src/components/lists/ListSalesVehicles/Item/index.tsx
import React, { useCallback } from 'react';

import { IoEllipse } from 'react-icons/io5';

import { ButtonMain, Paragraph } from '@components/index';
import { ConfigStyles, ConfigTransition, ConfigValues } from '@config/index';
import transition from '@config/transition';
import Car from '@models/Car';
import { apiRebox } from '@services/index';
import { formatDate } from '@utils/formatters';
import { toastify } from '@utils/notifiers';

import { Container } from './styles';

interface IProps {
  car: Car;
}

const ListCarsItem: React.FC<IProps> = ({ car }) => {
  const handleRemoveCar = useCallback(async (car_id: string) => {
    try {
      const { data: response } = await apiRebox.delete(`/cars/${car_id}`);

      const { header } = response;
      toastify(header.message, 'success');
    } catch (error: any) {
      if (error.response) {
        toastify(error.response.data.error, 'error');
      } else {
        toastify('Houve um erro ao remover o modelo veicular', 'error');
      }
    }
  }, []);

  return (
    <Container>
      <Paragraph nameColor="black" textAlign="start" fontSize={12}>
        {
          ConfigTransition.rebox_vehicles_classifications[
            car?.classification.toLowerCase() || 'undefined'
          ]
        }
      </Paragraph>
      <Paragraph nameColor="black" textAlign="start" fontSize={12}>
        {car?.brand.toUpperCase()}
      </Paragraph>
      <Paragraph nameColor="black" textAlign="start" fontSize={12}>
        {car?.model.toUpperCase()}
      </Paragraph>
      <Paragraph nameColor="black" textAlign="start" fontSize={12}>
        <IoEllipse
          size={10}
          color={
            ConfigValues.rebox.vehicle.status.active === car?.status
              ? ConfigStyles.rebox.colors.greenEmerald.main
              : ConfigStyles.rebox.colors.black.opacity.average
          }
        />
        {transition.rebox_cars_status[car?.status.toLowerCase()].toUpperCase()}
      </Paragraph>
      <Paragraph nameColor="black" textAlign="start" fontSize={12}>
        {car?.is_for_tracker_plan ? 'SIM' : 'NÃO'}
      </Paragraph>
      <Paragraph nameColor="black" textAlign="start" fontSize={12}>
        {formatDate.addMask(car?.created_at.split('T')[0])}
      </Paragraph>
      <ButtonMain onClick={() => handleRemoveCar(car?.id)}>Remover</ButtonMain>
    </Container>
  );
};

export default ListCarsItem;
